/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';
export const GET_CERTIFICATE = gql`
  query GetCertificate($credentialNo: String!) {
    getCertificate(credentialNo: $credentialNo) {
      issuanceDate
      type
      pdf
      legacy
      issuedTo {
        address {
          addressLine1
          addressLine2
          addressLine3
          country
          city
          parish
          state
          zipcode
        }
        alias
        childrenOrDependent
        countryConvicted
        criminalOffence
        dateOfBirth
        dateOfConviction
        dependentInfo {
          dependentType
          name
          passportNumber
          relationship
        }
        email
        firstName
        gender
        isLastNameExist
        lastEmployer {
          name
          wpExpiry
          credentialNo
          address {
            addressLine1
            addressLine2
            addressLine3
            city
            country
            parish
            state
            zipcode
          }
          primaryContactNo
        }
        lastName
        maritalStatus
        middleName
        nationality
        natureOfOffence
        occupation
        passportExpiry
        passportType
        passportNumber
        permissionPeriod {
          from
          to
        }
        placeOfBirth
        primaryContactNo
        qualification {
          degree
          description
          from
          institute
          to
        }
        skills
        spouseLastEmployer {
          name
          address {
            addressLine2
            addressLine1
            addressLine3
            city
            country
            parish
            state
            zipcode
          }
          wpExpiry
          credentialNo
        }
        spouseName
        trn
        vuid
        workExperience {
          jobDuty
          nameOfOrganization
          refLetter
          from
          to
        }
        workedInJamaica
        destinationCarribbeanState
        name
        natureOfBusiness
        natureOfProfessionalActivity
        purposeOfRelocation
        spouseNationality
      }
      validFrom
      validTill
      verifyURL
      credentialNo
      status
      renewalStatus
    }
  }
`;
